import { HelmetTitle } from "@/components/HelmetTitle/HelmetTitle";
import { MainPageHeader } from "@/containers/Layout/MainLayout/styled";
import { routes } from "@/helpers";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, element, node, oneOfType, string } from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ContentWrapper = styled.div`
  padding: 0 ${(props) => (props.mobile === "true" ? "1px" : "12px")};
  margin: 1rem 0 12px 0;
`;

const PageWrapper = ({
  children,
  pageTitle,
  backButtonRoute,
  noStyle = false,
  pageActions,
  noBackButton = false,
}) => {
  const navigate = useNavigate();

  const [navigateRoute] = useState(() => backButtonRoute || routes.dashboard);

  return (
    <>
      <HelmetTitle pageTitle={pageTitle} />
      <MainPageHeader
        onBack={() => {
          navigate(navigateRoute);
        }}
        backIcon={
          !noBackButton &&
          backButtonRoute && <FontAwesomeIcon icon={faArrowLeft} />
        }
        title={pageTitle}
      />
      {pageActions}
      {noStyle ? children : <ContentWrapper>{children}</ContentWrapper>}
    </>
  );
};

export default PageWrapper;

PageWrapper.propTypes = {
  children: node.isRequired,
  pageTitle: oneOfType([string, element]).isRequired,
  backButtonRoute: string,
  noStyle: bool,
  pageActions: element,
  noBackButton: bool,
};
